type Props = { value: string; kind?: 'severity' | 'enforcement' | 'inheritance' | 'status' };
const labels: Record<string, string> = {
  CRITICAL: 'Critical',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
  BLOCK: 'Block',
  REDIRECT: 'Redirect',
  REQUIRE_CONFIRMATION: 'Confirm',
  REQUIRE_AUTHENTICATION: 'Authenticate',
  ESCALATE: 'Escalate',
  WARN_INTERNAL: 'Warn',
  MONITOR: 'Inform',
  INHERITED: 'Inherited',
  OVERRIDDEN: 'Overridden',
  LOCAL: 'Local',
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  APPROVED: 'Approved',
  AWAITING_APPROVAL: 'Awaiting approval',
};
export function StatusBadge({ value, kind = 'status' }: Props) {
  return (
    <span className={`badge ${kind} value-${value.toLowerCase()}`}>{labels[value] ?? value}</span>
  );
}
